import clsx from "classnames";
import { Col, Container, Row } from "react-bootstrap";
import { MultiTileCard } from "@/ui";

export const MultiTiles = ({ className, items, bgColor }) => {
  return (
    <div className={clsx(className, `bg-${bgColor}`)}>
      <Container className="mw-xl">
        <Row>
          {items.map(({ title, img, href }, k) => (
            <Col key={k} xs={6} sm={4} md={3} lg={2} className="p-0">
              <MultiTileCard title={title} img={img?.url} href={href} />
            </Col>
          ))}
        </Row>
      </Container>
    </div>
  );
}

export default MultiTiles;